import { c as _c } from "react/compiler-runtime";
import { SpeechBubble } from "./SpeechBubble";
type ThinkingIndicatorProps = {
  text: string;
};
export const ThinkingIndicator: React.FC<ThinkingIndicatorProps> = t0 => {
  const $ = _c(5);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = <span className="justify-start text-black">{text}</span>;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-8 h-3 rounded-full overflow-hidden" aria-hidden="true"><div className="h-full w-[800%] motion-safe:animate-shimmer" style={{
        background: "linear-gradient(90deg, var(--color-purple-900) 0%, var(--color-purple-900) 15%, var(--color-purple-500) 40%, var(--color-purple-300) 50%, var(--color-purple-500) 60%, var(--color-purple-900) 85%, var(--color-purple-900) 100%)",
        backgroundSize: "50% 100%"
      }} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <SpeechBubble sender="assistant" className="flex items-center gap-2 w-fit" role="status" aria-live="polite">{t1}{t2}</SpeechBubble>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default ThinkingIndicator;